export default {
  LIST(state, data) {
    state.topics = data
  },
  GET(state, data) {
    state.topic = data
  },
  UPDATE(state, data) {
    state.topic = { ...data }
  },
  FRESH(state) {
    state.topic = {
      id: null,
      name_uz: '',
      name_ru: '',
      name_en: '',
      apply_doc: null,
      apply_doc_name: '',
      scientific_topic_protocol: null,
    }
  },
}
